module.exports = __webpack_public_path__ + "static/media/cpanel.9e90cf23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cpanel.svg
// module id = 260
// module chunks = 0